import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Huggg } from 'components';
import VoucherTypes from './Types/Types';
import dictionary from 'config/dictionary';
import styles from './voucher.module.scss';
import { SendQRCodeButton } from 'components/ui';
import {
  getRedeemedSegmentImage,
  getRedeemedSegmentName,
  shouldUseRedeemedSegmentInformation
} from 'utilities/huggg';
import { format, parseISO } from 'date-fns';
import { interpolate } from 'utilities/interpolate';
import SuccessIcon from 'components/SuccessIcon/SuccessIcon';

const VoucherClaimed = ({
  brand,
  huggg,
  vouchers,
  voucherExpiry,
  redeemedSegment,
  hideProductImage,
  isFormRedemptionType,
  isPin4Type,
  isPrepaidCardType,
  isBlueHuggg,
  onSendQRCodeEmail
}) => {
  const redeemedSegmentImage = shouldUseRedeemedSegmentInformation(huggg)
    ? getRedeemedSegmentImage(huggg)
    : null;

  const redeemedSegmentName = shouldUseRedeemedSegmentInformation(huggg)
    ? getRedeemedSegmentName(huggg)
    : null;

  const formattedVoucherExpiry = voucherExpiry
    ? format(parseISO(voucherExpiry), 'do MMM yyyy')
    : null;

  const shouldShowSuccessMessaging = redeemedSegment?.voucherType === 'tillo';

  const shouldShowVoucherExpiry =
    Boolean(formattedVoucherExpiry) &&
    !isFormRedemptionType &&
    !isPin4Type &&
    !isPrepaidCardType;

  const showSendQRCodeButton =
    vouchers?.length && vouchers.some(item => item.type === 'qr');

  const isTilloVoucher = useMemo(() => {
    return vouchers[0].voucherType === 'tillo' && vouchers[0].type === 'fulfil';
  }, [vouchers]);

  return (
    <>
      <div style={{ marginBottom: '20px' }}>
        {shouldShowSuccessMessaging && (
          <div className={styles.successIconWrapper}>
            <div className={styles.successIcon}>
              <SuccessIcon alt="Success" scale={1} />
            </div>
            <p>
              {interpolate(
                isTilloVoucher
                  ? dictionary.voucherSelected
                  : dictionary.voucherClaimed,
                '[brand_name]',
                <>{brand.name}</>
              )}
            </p>
          </div>
        )}
        <Huggg
          huggg={huggg}
          hideImage={hideProductImage}
          imageOverride={redeemedSegmentImage}
          titleOverride={redeemedSegmentName}
          hideDescription={Boolean(redeemedSegmentName)}
        />
      </div>
      <VoucherTypes
        huggg={huggg}
        brandName={brand.name}
        vouchers={vouchers}
        redeemedSegment={redeemedSegment}
        data-test-id="voucher-image"
        isBlueHuggg={isBlueHuggg}
      />
      {shouldShowVoucherExpiry && (
        <p className={styles.voucherExpiry}>
          {interpolate(
            dictionary.voucherExpiry,
            '[expiry_date]',
            <>{formattedVoucherExpiry}</>
          )}
        </p>
      )}

      {showSendQRCodeButton && (
        <div className={styles.buttonContainer}>
          <SendQRCodeButton
            hugggId={huggg.id}
            onSendQRCodeEmail={onSendQRCodeEmail}
          />
        </div>
      )}
    </>
  );
};

VoucherClaimed.propTypes = {
  brand: PropTypes.object.isRequired,
  huggg: PropTypes.object.isRequired,
  vouchers: PropTypes.array,
  voucherExpiry: PropTypes.string,
  isFormRedemptionType: PropTypes.bool,
  isPin4Type: PropTypes.bool,
  isPrepaidCardType: PropTypes.bool,
  redeemedSegment: PropTypes.object,
  hideProductImage: PropTypes.bool,
  onSendQRCodeEmail: PropTypes.func,
  isBlueHuggg: PropTypes.bool,
  defaultTerritory: PropTypes.string
};

export default VoucherClaimed;
